/**
 * This file is designed only for the events related to lead stuff. For example, when we submit one.
 * It usually means that usually the action should have to save information on the store.
 */

import GoogleTagManager from 'middlewares/googleTagManager';
import uiStateSlice from 'layout/redux/uiStateSlice';
import { createMiddleware } from 'redux-beacon';
import { addMiddleware } from 'redux-dynamic-middlewares';

const getGoogleAnalyticsDTO = (action) => action.payload.googleAnalyticsDTO;
const uiStateActions = uiStateSlice.actions;

const eventsMapper = (action) => {
  switch (action.type) {
    case uiStateActions.fetchModal.type: {
      const isValid = getGoogleAnalyticsDTO(action);
      return isValid ? getGoogleAnalyticsDTO : [];
    }
    default:
      return [];
  }
};

const googleTagManager = new GoogleTagManager();
const searchResultsGoogleTagManagerMiddleware = createMiddleware(eventsMapper, googleTagManager.getTarget());
addMiddleware(searchResultsGoogleTagManagerMiddleware);
